import { ArrowRight } from "lucide-react";
import { MaskedLine, FadeUp, Overline } from "../components/Reveal";
import { useEnquiry } from "../context/EnquiryContext";
import { BRANDS_ASSOCIATIONS, BRANDS_AUTHORIZED } from "../data/content";

export default function Brands() {
  const { openEnquiry } = useEnquiry();

  return (
    <main data-testid="brands-page">
      <section className="pt-32 sm:pt-44 pb-14 sm:pb-20 px-5 sm:px-8 lg:px-12 border-b border-ink/15">
        <FadeUp immediate y={12}>
          <Overline className="mb-8">Brand Associations</Overline>
        </FadeUp>
        <h1 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-[13vw] sm:text-8xl">
          <MaskedLine immediate delay={0.15}>Brands We</MaskedLine>
          <MaskedLine immediate delay={0.3}>Work With</MaskedLine>
        </h1>
        <FadeUp immediate delay={0.45} className="mt-8 max-w-xl">
          <p className="text-base sm:text-lg text-ink/65 leading-relaxed">
            Trusted products. Established associations.
          </p>
        </FadeUp>
      </section>

      <section className="px-5 sm:px-8 lg:px-12 py-16 sm:py-24 border-b border-ink/15 bg-white">
        <FadeUp>
          <Overline className="mb-8">Authorized Dealer</Overline>
        </FadeUp>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-ink/15 border border-ink/15">
          {BRANDS_AUTHORIZED.map((brand) => (
            <div
              key={brand.name}
              data-testid={`authorized-brand-${brand.name.toLowerCase()}`}
              className="bg-white px-8 py-14 sm:py-20 flex flex-col items-start justify-center"
            >
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-ink/40 mb-6">
                Authorized Dealer
              </span>
              <img
                src={brand.logo}
                alt={`${brand.name} logo`}
                className="h-24 sm:h-32 w-auto object-contain mix-blend-multiply"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </section>

      <section className="px-5 sm:px-8 lg:px-12 py-16 sm:py-24 border-b border-ink/15">
        <FadeUp>
          <Overline className="mb-8">Our Brand Associations</Overline>
        </FadeUp>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-ink/15 border border-ink/15">
          {BRANDS_ASSOCIATIONS.map((brand, i) => (
            <FadeUp key={brand.name} delay={i * 0.03}>
              <div
                data-testid={`brand-${brand.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="bg-paper px-6 py-12 sm:py-16 h-full flex items-center justify-center hover:bg-white transition-colors"
              >
                {brand.logo ? (
                  <img
                    src={brand.logo}
                    alt={`${brand.name} logo`}
                    className="max-h-12 sm:max-h-16 w-auto max-w-full object-contain mix-blend-multiply"
                    loading="lazy"
                  />
                ) : (
                  <span className="font-display font-extrabold uppercase tracking-tight text-lg sm:text-2xl text-ink/70 text-center">
                    {brand.name}
                  </span>
                )}
              </div>
            </FadeUp>
          ))}
        </div>
        <p className="mt-8 font-mono text-[10px] tracking-[0.15em] uppercase text-ink/40">
          All brand names are the property of their respective owners.
        </p>
      </section>

      <section className="bg-ink text-paper px-5 sm:px-8 lg:px-12 py-16 sm:py-24">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.92] text-3xl sm:text-5xl max-w-2xl">
            Need a specific brand or specification?
          </h2>
          <button
            data-testid="brands-bottom-cta"
            onClick={() => openEnquiry("")}
            className="inline-flex items-center gap-2 bg-accent text-ink font-mono text-xs tracking-[0.2em] uppercase px-8 py-5 hover:bg-paper transition-colors self-start"
          >
            Send Your Requirement <ArrowRight size={14} />
          </button>
        </div>
      </section>
    </main>
  );
}
